// context/UnauthorizedContext.jsx
import React, { createContext, useContext, useEffect, useState } from 'react';
import { setPopupHandler } from '../services/axiosInstance';

const UnauthorizedContext = createContext();
//export let unauthorizedHandler = null; // will be linked to context function


export const UnauthorizedProvider = ({ children }) => {
  const [isUnauthorized, setIsUnauthorized] = useState(false);

  useEffect(() => {
    // setPopupHandler(setIsUnauthorized);
  }, []);

  return (
    <UnauthorizedContext.Provider value={{isUnauthorized, setIsUnauthorized} }>
      {children}
    </UnauthorizedContext.Provider>
  );
};

export const useUnauthorized = () => useContext(UnauthorizedContext);
